import { default as localeCustomizations } from './locales'
import { default as containerCustomizations } from './customizations'
import { IPartnerConfig } from '../../internal'

import logoLight from './assets/remote_lock_teal_logo_single_line.png';
import logoDark from './assets/remotelock-logo-dark-mode.png';

// must export all of these for each partner. Empty if using defaults
const partnerCustomizations: IPartnerConfig = {
  assets: {
    logoOnBackground: logoLight,
    logoOnSecondary: logoLight,
    logoOnPrimary: logoLight,
    logoOnDark: logoDark
  },
  locales: localeCustomizations,
  containers: containerCustomizations,
}
export default partnerCustomizations;